// extracted by mini-css-extract-plugin
export default {"container":"Chat_container__MPNR7","messageWrapper":"Chat_messageWrapper__N9pOb","buttons":"Chat_buttons__Ei27d"};